import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Instagram, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-serif-logo text-2xl font-medium tracking-[0.15em] text-black mb-4">
              SATIS FURNITURE
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed max-w-xs">
              Revitalize your space with our exquisite furniture collection and make every corner a reflection of your style
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-base text-black mb-5">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-gray-600 hover:text-black transition-colors">Home</Link></li>
              <li><Link to="/furniture" className="text-sm text-gray-600 hover:text-black transition-colors">Furniture</Link></li>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-black transition-colors">About Us</Link></li>
              <li><Link to="/contact-us" className="text-sm text-gray-600 hover:text-black transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Furniture */}
          <div>
            <h4 className="font-medium text-base text-black mb-5">
              <Link to="/furniture" className="hover:underline">Furniture</Link>
            </h4>
            <ul className="space-y-3">
              <li><Link to="/furniture" className="text-sm text-gray-600 hover:text-black transition-colors">All products</Link></li>
              <li><Link to="/furniture#bed" className="text-sm text-gray-600 hover:text-black transition-colors">Beds</Link></li>
              <li><Link to="/furniture#mat" className="text-sm text-gray-600 hover:text-black transition-colors">Mattress</Link></li>
              <li><Link to="/furniture#war" className="text-sm text-gray-600 hover:text-black transition-colors">Wardrobes</Link></li>
            </ul>
          </div>

          {/* Visiting Hours */}
          <div>
            <h4 className="font-medium text-base text-black mb-5">Visiting Hours</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>Mon-Sat : 10:30am to 5:30pm</li>
              <li>Sun: 11AM - 5PM</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="flex items-start gap-3 mb-5">
              <Phone className="w-4 h-4 text-black mt-1 flex-shrink-0" strokeWidth={1.5} />
              <div>
                <h4 className="font-medium text-base text-black mb-1">Phone No</h4>
                <p className="text-sm text-gray-600">(02) 97872567 / 0430890808 / 0411418088</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-black mt-1 flex-shrink-0" strokeWidth={1.5} />
              <div>
                <h4 className="font-medium text-base text-black mb-1">E-mail</h4>
                <a href="mailto:wangjianjohn@hotmail.com" className="text-sm text-gray-600 hover:text-black transition-colors">
                  wangjianjohn@hotmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mt-12 pt-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <span className="text-sm text-black font-medium">Follow Us :</span>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-black hover:text-white hover:border-black transition-colors btn-transition">
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
              </a>
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-black hover:text-white hover:border-black transition-colors btn-transition">
                <Facebook className="w-4 h-4" strokeWidth={1.5} />
              </a>
              <a href="#" aria-label="LinkedIn" className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-black hover:text-white hover:border-black transition-colors btn-transition">
                <Linkedin className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
            <p className="text-sm text-gray-500">Copyright © 2024 SATIS. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
